import { createVanIconComponent } from "./van"

const TodoList = createVanIconComponent("todo-list")
export default TodoList
